import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Button } from '@efexteam/components';
import { errorIcon } from '../../assets';
import CollectErrors, { CollectedError } from './ErrorRetry.service';

interface ErrorRetryProps {
  icon?: JSX.Element | null;
  showImage?: boolean;
  message?: string;
  classNamesMessage?: string;
  buttonClassNames?: string;
  onRetry?: () => void;
  buttonMessage?: string;
  objectError?: { [key: string]: any };
  isMessageObject?: boolean;
  centered?: boolean;
}

const ErrorRetry = ({
  icon,
  showImage = true,
  onRetry,
  buttonMessage,
  message,
  classNamesMessage,
  buttonClassNames,
  objectError,
  isMessageObject = false,
  centered = false,
}: ErrorRetryProps) => {
  const { t } = useTranslation();
  const collectedErrors: CollectedError[] = objectError
    ? CollectErrors(objectError)
    : [];
  return (
    <div
      className={
        centered
          ? 'flex flex-col items-center justify-center min-h-screen'
          : 'flex flex-col items-start justify-center h-100'
      }
    >
      {icon ||
        (showImage && (
          <img
            className="max-w-[85px] max-h-[85px] m-3"
            src={errorIcon}
            alt="retry-error"
          />
        ))}
      <h2
        className={clsx(
          'text-sm font-medium text-red-400 mt-3 mb-2',
          classNamesMessage
        )}
      >
        {collectedErrors && isMessageObject
          ? collectedErrors.map((error) => (
              <div key={error.errorMessage}>{error.errorMessage}</div>
            ))
          : null}
        {message && !isMessageObject ? message : null}
        {!message && !objectError && t('errorRetryMessage')}
      </h2>
      {onRetry && (
        <Button
          appearance="primary"
          className={buttonClassNames}
          onClick={onRetry}
        >
          {buttonMessage || t('errorRetry')}
        </Button>
      )}
    </div>
  );
};

export default ErrorRetry;
